import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
	return axios.get(`/get/student-financial-support/student-course-session/${courseSessionId}`, { params })
}
